import React from 'react';

const Container = ({ children, className = '' }) => {
  const containerClasses = `container${className ? ` ${className}` : ''}`;
  return <div className={containerClasses}>{children}</div>;
};

export default Container;
